import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01fd6a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vertical-ad" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"358px","margin":"20px"} }, [
  /*#__PURE__*/_createElementVNode("ins", {
    class: "adsbygoogle",
    style: {"display":"inline-block","width":"318px","height":"400px"},
    "data-ad-client": "ca-pub-9536942955148440",
    "data-ad-slot": "4831213676"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}